// extracted by mini-css-extract-plugin
export default {"images-wrapper":"view-images-modal_images-wrapper__OiqOf"};